import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { ClientsPicker } from '@src/components/ClientsPicker';
import { SAVE_MACRO } from '@src/graphql/queries/macro';
import { prepareForSave } from '@src/utilities/gqlHelper';
import { omit } from 'lodash';
import { Form, useAlert, useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
export const EditMacro = ({ macro }) => {
    const navigate = useNavigate();
    const { t } = useLocale();
    const { showAlert } = useAlert();
    const [saveMacro] = useMutation(SAVE_MACRO);
    const handleValidate = (macro) => {
        const errors = {};
        if (!macro.category) {
            errors.category = t('required');
        }
        if (!macro.title) {
            errors.title = t('required');
        }
        if (!macro.content) {
            errors.content = t('required');
        }
        return errors;
    };
    const formFields = useMemo(() => {
        return [
            {
                name: 'category',
                label: t('Category'),
            },
            {
                name: 'title',
                label: t('Title'),
            },
            {
                name: 'content',
                label: t('Content'),
                type: 'textarea',
                plainText: false,
                helpText: t('Macro placeholders list'),
            },
            {
                name: 'tags',
                label: t('Tags'),
                type: 'textarea',
                infoText: 'One on each line',
                plainText: true,
                serializeValue: (value) => value.join('\n'),
                deserializeValue: (value) => value.split('\n'),
            },
            {
                name: 'isGeneric',
                label: t('Applies to all employers?'),
                type: 'boolean',
                serializeValue: (value) => (value ? 'true' : 'false'),
                deserializeValue: (value) => value === 'true',
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSave = async (macro) => {
        try {
            const result = await saveMacro({
                variables: {
                    input: {
                        ...omit(prepareForSave(macro), 'clients'),
                        id: macro.id ? macro.id : null,
                        tags: macro.tags.filter(tag => tag.trim() !== ''), // remove empty tags
                        clientIds: macro.isGeneric ? [] : macro.clientIds,
                    },
                },
            });
            if (result.data?.saveMacro && !result.data.saveMacro.success) {
                return result.data.saveMacro;
            }
            const message = result.data.saveMacro.messages[0];
            const toShow = t(message.value, { values: message.params });
            showAlert(toShow, 'success');
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            throw new Error(t('Unable to save macro'));
        }
    };
    return (_jsx(Form, { fields: formFields, title: '', modal: false, obj: macro, onValidate: handleValidate, onSave: handleSave, minHeight: 150, onCancel: () => {
            navigate('/admin/macros');
        }, children: ({ draft, setDraft }) => (_jsx(_Fragment, { children: !draft.isGeneric && (_jsx(ClientsPicker, { clientIds: draft.clientIds || [], onChange: clientIds => setDraft({ ...draft, clientIds }) })) })) }));
};
